module.exports = __webpack_public_path__ + "static/media/Minh_Do.073bcba4.svg";